module.exports = __webpack_public_path__ + "static/media/motion_img.4a203f0c.jpg";